import { AkebonoCoreModule } from '@akebono/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { ResizeImagePipeModule } from 'src/app/pipes/resize-image-pipe/resize-image-pipe.module';

import { LotAddPhotoImagesSorterItemComponent } from './components/images-sorter/lot-add-photo-images-sorter-item/lot-add-photo-images-sorter-item.component';
import { LotAddPhotoImagesSorterComponent } from './components/images-sorter/lot-add-photo-images-sorter/lot-add-photo-images-sorter.component';
import { LotAddPhotoModalSortViewComponent } from './components/modal/lot-add-photo-modal-sort-view/lot-add-photo-modal-sort-view.component';
import { LotAddPhotoModalUploadViewComponent } from './components/modal/lot-add-photo-modal-upload-view/lot-add-photo-modal-upload-view.component';
import { LotAddPhotoModalComponent } from './components/modal/lot-add-photo-modal/lot-add-photo-modal.component';
import { LotAddPhotoUploadingListItemAddComponent } from './components/uploading-list/lot-add-photo-uploading-list-item-add/lot-add-photo-uploading-list-item-add.component';
import { LotAddPhotoUploadingListItemErrorComponent } from './components/uploading-list/lot-add-photo-uploading-list-item-error/lot-add-photo-uploading-list-item-error.component';
import { LotAddPhotoUploadingListItemPreviewOverlayComponent } from './components/uploading-list/lot-add-photo-uploading-list-item-preview-overlay/lot-add-photo-uploading-list-item-preview-overlay.component';
import { LotAddPhotoUploadingListItemPreviewComponent } from './components/uploading-list/lot-add-photo-uploading-list-item-preview/lot-add-photo-uploading-list-item-preview.component';
import { LotAddPhotoUploadingListItemProgressComponent } from './components/uploading-list/lot-add-photo-uploading-list-item-progress/lot-add-photo-uploading-list-item-progress.component';
import { LotAddPhotoUploadingListItemComponent } from './components/uploading-list/lot-add-photo-uploading-list-item/lot-add-photo-uploading-list-item.component';
import { LotAddPhotoUploadingListComponent } from './components/uploading-list/lot-add-photo-uploading-list/lot-add-photo-uploading-list.component';
import { LotAddPhotoButtonComponent } from './lot-add-photo-button.component';

@NgModule({
  declarations: [
    LotAddPhotoButtonComponent,
    LotAddPhotoModalComponent,
    LotAddPhotoUploadingListComponent,
    LotAddPhotoUploadingListItemComponent,
    LotAddPhotoUploadingListItemAddComponent,
    LotAddPhotoUploadingListItemProgressComponent,
    LotAddPhotoUploadingListItemErrorComponent,
    LotAddPhotoUploadingListItemPreviewComponent,
    LotAddPhotoUploadingListItemPreviewOverlayComponent,
    LotAddPhotoImagesSorterComponent,
    LotAddPhotoImagesSorterItemComponent,
    LotAddPhotoModalUploadViewComponent,
    LotAddPhotoModalSortViewComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    AkebonoCoreModule,
    TranslateModule,
    BrowserAnimationsModule,
    ResizeImagePipeModule,
    NzButtonModule,
    NzIconModule,
    NzGridModule,
    NzImageModule,
    NzProgressModule,
    NzToolTipModule,
    NzSpaceModule,
    NzSwitchModule,
    NzModalModule,
  ],
  exports: [LotAddPhotoButtonComponent],
})
export class LotAddPhotoButtonModule {}
